var Accordion = class extends HTMLElement {
  constructor() {
    super();
    this.accordionHeader = this.querySelector(".footer__block__title");
  }

  connectedCallback() {
    this.accordionHeader.addEventListener("click", () => {
      this.toggleAccordion();
    });
  }

  toggleAccordion() {
    this.classList.toggle("open");
  }
};

if (!window.customElements.get("footer-accordion")) {
  window.customElements.define("footer-accordion", Accordion);
}

var CNILValidate = class extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll(".cnil-validate");
    this.radioButton = this.querySelector('input[name="cnil-checkbox-validate"]');
  }

  connectedCallback() {
    this.radioButton.addEventListener("change", () => {
      this.toggleButton(this.radioButton.checked);
    })
  }

  toggleButton(checked) {
    this.buttons.forEach(
      button => button.disabled = !checked
    )
  }
};

if (!window.customElements.get("cnil-validate")) {
  window.customElements.define("cnil-validate", CNILValidate);
}
